/* No Leaks PDP + cart interactions */
(function () {
  'use strict';

  function money(cents) {
    var fmt = window.nlMoneyFormat || '${{amount}}';
    var withSep = function (n, dec) {
      var s = dec ? n.toFixed(2) : String(Math.round(n));
      var parts = s.split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    };
    var amount = cents / 100;
    return fmt
      .replace(/\{\{\s*amount\s*\}\}/g, withSep(amount, true))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, withSep(amount, false))
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.toFixed(2).replace('.', ',').replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, String(Math.round(amount)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/<[^>]+>/g, '');
  }

  /* ---------------- gallery ---------------- */
  function initGallery(root) {
    var track = root.querySelector('[data-nl-track]');
    if (!track) return;
    var slides = track.children;
    var dots = root.querySelectorAll('[data-nl-dots] span');
    var thumbs = root.querySelectorAll('[data-nl-thumbs] button');

    function setActive(i) {
      dots.forEach && dots.forEach(function (d, j) { d.classList.toggle('is-active', j === i); });
      thumbs.forEach && thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }
    track.addEventListener('scroll', function () {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      setActive(i);
    }, { passive: true });
    thumbs.forEach && thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.dataset.index, 10) || 0;
        track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
        setActive(i);
      });
    });
  }

  /* ---------------- buy box ---------------- */
  function initBuyBox(box) {
    var tiers = Array.prototype.slice.call(box.querySelectorAll('.nl-tile, .nl-tier:not([data-nl-addon])'));
    var priceEl = box.querySelector('[data-nl-price]');
    var compareEl = box.querySelector('[data-nl-compare]');
    var atcBtns = Array.prototype.slice.call(document.querySelectorAll('[data-nl-atc]'));
    var errEl = box.querySelector('[data-nl-atc-error]');
    var addon = box.querySelector('[data-nl-addon]');
    var stickyPrice = document.querySelector('[data-nl-sticky-price]');
    var stickyCompare = document.querySelector('[data-nl-sticky-compare]');
    var addUrl = box.dataset.cartAddUrl || '/cart/add';
    var cartUrl = box.dataset.cartUrl || '/cart';

    /* colour picker: the tier decides HOW MANY umbrellas, the swatches decide which */
    var colorsWrap = box.querySelector('[data-nl-colors]');
    var swatches = Array.prototype.slice.call(box.querySelectorAll('[data-nl-swatch]'));
    var pickedEl = box.querySelector('[data-nl-picked]');
    var unitsEl = box.querySelector('[data-nl-units]');
    var colorsHint = box.querySelector('[data-nl-colors-hint]');
    var counts = [];
    var units = 1;

    function totalPicked() {
      return counts.reduce(function (a, b) { return a + b; }, 0);
    }
    function colorSummary() {
      var parts = [];
      counts.forEach(function (n, i) {
        if (n > 0) parts.push(swatches[i].dataset.name + (n > 1 ? ' x' + n : ''));
      });
      return parts.join(', ');
    }
    function spread(n) {
      counts = swatches.map(function () { return 0; });
      if (!swatches.length) return;
      for (var j = 0; j < n; j++) counts[j % swatches.length] += 1;
    }
    function renderColors() {
      var single = units === 1;
      if (colorsWrap) {
        colorsWrap.classList.toggle('is-single', single);
        var titleEl = colorsWrap.querySelector('[data-nl-colors-title]');
        var wanted = single ? colorsWrap.dataset.titleOne : colorsWrap.dataset.titleMany;
        if (titleEl && wanted) titleEl.textContent = wanted;
      }
      swatches.forEach(function (sw, i) {
        sw.classList.toggle('is-picked', counts[i] > 0);
        var q = sw.querySelector('[data-nl-qty]');
        if (q) q.textContent = counts[i];
        var minus = sw.querySelector('[data-nl-minus]');
        if (minus) minus.disabled = counts[i] === 0;
        var plus = sw.querySelector('[data-nl-plus]');
        if (plus) plus.disabled = totalPicked() >= units;
      });
      var total = totalPicked();
      if (pickedEl) pickedEl.textContent = total;
      if (unitsEl) unitsEl.textContent = units;
      var short = units - total;
      if (colorsHint) {
        colorsHint.textContent = short > 0
          ? 'Pick ' + short + ' more to continue'
          : (single ? '' : 'Nice mix \u2014 ' + colorSummary());
      }
    }
    function bump(i, delta) {
      var next = counts[i] + delta;
      if (next < 0) return;
      if (delta > 0 && totalPicked() >= units) {
        if (units === 1) { spread(0); counts[i] = 1; renderColors(); }
        return;
      }
      counts[i] = next;
      renderColors();
    }
    swatches.forEach(function (sw, i) {
      var chip = sw.querySelector('[data-nl-chip]');
      if (chip) chip.addEventListener('click', function () {
        if (units === 1) { spread(0); counts[i] = 1; renderColors(); }
        else bump(i, 1);
      });
      var plus = sw.querySelector('[data-nl-plus]');
      var minus = sw.querySelector('[data-nl-minus]');
      if (plus) plus.addEventListener('click', function () { bump(i, 1); });
      if (minus) minus.addEventListener('click', function () { bump(i, -1); });
    });

    function currentTier() {
      return box.querySelector('.nl-tile.is-active') || box.querySelector('.nl-tier.is-active') || tiers[0];
    }

    function refresh() {
      var t = currentTier();
      if (!t) return;
      var price = parseInt(t.dataset.price, 10) || 0;
      var compare = parseInt(t.dataset.compare, 10) || 0;
      if (addon && addon.querySelector('input') && addon.querySelector('input').checked) {
        price += parseInt(addon.dataset.price, 10) || 0;
        if (compare) compare += parseInt(addon.dataset.price, 10) || 0;
      }
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) compareEl.textContent = compare > price ? money(compare) : '';
      if (stickyPrice) stickyPrice.textContent = money(price);
      if (stickyCompare) stickyCompare.textContent = compare > price ? money(compare) : '';
    }

    tiers.forEach(function (t) {
      t.addEventListener('click', function () {
        tiers.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
        units = parseInt(t.dataset.units, 10) || 1;
        spread(units);
        renderColors();
        refresh();
      });
    });
    var def = box.querySelector('.nl-tile[data-default]') || box.querySelector('.nl-tier[data-default]') || tiers[0];
    if (def) {
      def.classList.add('is-active');
      units = parseInt(def.dataset.units, 10) || 1;
      spread(units);
      renderColors();
    }
    if (addon) {
      var input = addon.querySelector('input');
      input && input.addEventListener('change', refresh);
    }
    refresh();

    function showError(msg) {
      if (!errEl) return;
      errEl.textContent = msg;
      errEl.hidden = false;
    }

    function addToCart() {
      var t = currentTier();
      if (!t) return;
      var variantId = t.dataset.variantId;
      if (!variantId) { showError('This option is unavailable right now. Please refresh and try again.'); return; }
      if (swatches.length && totalPicked() !== units) {
        showError('Pick ' + (units - totalPicked()) + ' more colour' + (units - totalPicked() === 1 ? '' : 's') + ' to continue.');
        if (colorsWrap) colorsWrap.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }
      var items = [{ id: parseInt(variantId, 10), quantity: parseInt(t.dataset.qty, 10) || 1 }];
      var summary = colorSummary();
      if (summary) items[0].properties = { Colors: summary };
      if (addon) {
        var input = addon.querySelector('input');
        var addonId = parseInt(addon.dataset.variantId, 10);
        if (input && input.checked && addonId) items.push({ id: addonId, quantity: 1 });
      }
      atcBtns.forEach(function (b) { b.setAttribute('disabled', ''); b.dataset.origHtml = b.innerHTML; b.textContent = 'Adding…'; });
      fetch(addUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (r) {
          return r.json().then(function (data) {
            if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart. Please try again.');
            return data;
          });
        })
        .then(function () {
          if (window.fbq) {
            try {
              fbq('track', 'AddToCart', {
                content_ids: [parseInt(variantId, 10)],
                content_type: 'product',
                value: (parseInt(t.dataset.price, 10) || 0) / 100,
                currency: window.nlCurrency || 'USD',
              });
            } catch (e) {}
          }
          window.location.href = cartUrl;
        })
        .catch(function (err) {
          showError(err.message || 'Could not add to cart. Please try again.');
          atcBtns.forEach(function (b) { b.removeAttribute('disabled'); if (b.dataset.origHtml) b.innerHTML = b.dataset.origHtml; });
        });
    }

    atcBtns.forEach(function (b) { b.addEventListener('click', addToCart); });

    /* sticky bar visibility */
    var sticky = document.querySelector('[data-nl-stickybar]');
    if (sticky && 'IntersectionObserver' in window) {
      var obs = new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0 });
      obs.observe(box);
    }

    /* delivery estimate */
    var d = box.querySelector('[data-nl-delivery-days]');
    if (d) {
      var days = parseInt(d.dataset.cfDeliveryDays, 10) || 5;
      var from = new Date(); from.setDate(from.getDate() + days);
      var to = new Date(); to.setDate(to.getDate() + days + 3);
      var fmt = { month: 'short', day: 'numeric' };
      d.textContent = from.toLocaleDateString('en-US', fmt) + ' – ' + to.toLocaleDateString('en-US', fmt);
    }
  }

  /* ---------------- cart page ---------------- */
  function initCart(root) {
    function busy(el) { el.style.opacity = '.5'; el.style.pointerEvents = 'none'; }

    root.querySelectorAll('[data-nl-qty]').forEach(function (q) {
      var line = parseInt(q.dataset.line, 10);
      var qty = parseInt(q.dataset.qty, 10);
      q.querySelector('[data-minus]').addEventListener('click', function () { change(line, qty - 1, q); });
      q.querySelector('[data-plus]').addEventListener('click', function () { change(line, qty + 1, q); });
    });
    root.querySelectorAll('[data-nl-remove]').forEach(function (b) {
      b.addEventListener('click', function () { change(parseInt(b.dataset.line, 10), 0, b); });
    });

    function change(line, quantity, el) {
      busy(root);
      fetch((window.routes && window.routes.cart_change_url || '/cart/change') + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) }),
      }).then(function () { window.location.reload(); });
    }

    root.querySelectorAll('[data-nl-upsell-add]').forEach(function (b) {
      b.addEventListener('click', function () {
        var id = parseInt(b.dataset.variantId, 10);
        if (!id) return;
        b.textContent = 'Adding…';
        fetch((window.routes && window.routes.cart_add_url || '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: 1 }] }),
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.reload();
        }).catch(function () { b.textContent = 'Try again'; });
      });
    });
  }

  /* ---------------- scroll reveal ---------------- */
  function initReveal() {
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;
    if (window.Shopify && Shopify.designMode) return;
    var targets = document.querySelectorAll(
      '.nl-sechead, .nl-dive, .nl-feature, .nl-problem__card, .nl-hs__panel, .nl-hs__chip, ' +
      '.nl-own__card, .nl-own__photo, .nl-num__item, .nl-num__media, .nl-stats > div, .nl-guarantee'
    );
    var pending = [];
    function show(el) { el.classList.add('is-in'); }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { show(e.target); obs.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px 12% 0px', threshold: 0.01 });
    targets.forEach(function (t) {
      if (t.classList.contains('nl-reveal')) return;
      t.classList.add('nl-reveal');
      var sibs = t.parentElement ? Array.prototype.indexOf.call(t.parentElement.children, t) : 0;
      t.style.transitionDelay = Math.min(sibs * 45, 135) + 'ms';
      obs.observe(t);
      pending.push(t);
    });
    /* safety sweep: fast scrolls can outrun the observer — anything whose top
       has entered (or passed) the viewport gets revealed and dropped */
    function sweep() {
      pending = pending.filter(function (t) {
        if (t.classList.contains('is-in')) return false;
        var top = t.getBoundingClientRect().top;
        if (top < window.innerHeight + 60) { show(t); obs.unobserve(t); return false; }
        return true;
      });
      if (!pending.length) {
        window.removeEventListener('scroll', onScroll);
      }
    }
    var ticking = false;
    function onScroll() {
      if (ticking) return;
      ticking = true;
      setTimeout(function () { ticking = false; sweep(); }, 250);
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    sweep();
  }

  function init() {
    document.querySelectorAll('[data-nl-gallery]').forEach(initGallery);
    document.querySelectorAll('[data-nl-buybox]').forEach(initBuyBox);
    document.querySelectorAll('[data-nl-cart]').forEach(initCart);
    initReveal();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  document.addEventListener('shopify:section:load', init);
})();
